import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Form, reduxForm } from 'redux-form';
import { propArrayStr, propFunc, propShape, ReduxFormProps, } from '../../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../../helpers/recompose';
import SubmitButton from '../../../../../../Ui/Button/SubmitButton';
import AccountBillingInformationField from '../../Common/Field/AccountBillingInformation/AccountBillingInformationField';
const AccountBillingInformationFormInner = (props) => {
    const { admin, enableDomains, form, handleSubmit, hideForm, invalid, submitting, } = props;
    return (_jsxs(Form, Object.assign({ className: 'account_billing_information_form', onSubmit: handleSubmit }, { children: [_jsx("div", Object.assign({ className: 'form-row' }, { children: _jsx(AccountBillingInformationField, { admin: admin, enableDomains: enableDomains, form: form }) })), _jsxs("div", Object.assign({ className: 'form-actions' }, { children: [_jsx("button", Object.assign({ className: 'button secondary', disabled: submitting, onClick: hideForm, type: 'button' }, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB" })), _jsx(SubmitButton, { className: 'button primary', isDisabled: submitting || invalid, isLoading: submitting, text: '保存' })] }))] })));
};
AccountBillingInformationFormInner.propTypes = Object.assign(Object.assign({}, ReduxFormProps), { hideForm: propFunc().isRequired });
const AccountBillingInformationForm = compose(reduxForm({ form: 'AccountBillingInformationForm' }))(AccountBillingInformationFormInner);
AccountBillingInformationForm.propTypes = {
    admin: propShape(),
    enableDomains: propArrayStr().isRequired,
    hideForm: propFunc().isRequired,
    initialValues: propShape().isRequired,
    onSubmit: propFunc().isRequired,
};
AccountBillingInformationForm.defaultProps = {
    admin: undefined,
};
export default AccountBillingInformationForm;
